import cx from 'classnames'
import styles from './StompSwitch.module.css'

export interface StompSwitchProps {
  /** Label shown under the button */
  label: string
  /** Whether the effect is engaged */
  engaged: boolean
  /** Called with the new state when the button is pressed */
  onChange: (engaged: boolean) => void
  /** Status pill text when engaged */
  engagedLabel?: string
  /** Status pill text when bypassed */
  bypassedLabel?: string
  /** Additional CSS class */
  className?: string
}

/**
 * A latching foot-pedal style button with a status lamp.
 * The lamp and status pill mirror the pressed state.
 */
export function StompSwitch({
  label,
  engaged,
  onChange,
  engagedLabel = 'Engaged',
  bypassedLabel = 'Bypassed',
  className,
}: StompSwitchProps) {
  return (
    <div
      className={cx(styles.StompSwitch, className, {
        [styles.isEngaged]: engaged,
      })}
    >
      <div
        className={styles.StompSwitch__lamp}
        aria-hidden="true"
      />
      <button
        className={styles.StompSwitch__button}
        type="button"
        aria-pressed={engaged}
        aria-label={label}
        onClick={() => onChange(!engaged)}
      />
      <span className={styles.StompSwitch__label}>{label}</span>
      <span className={styles.StompSwitch__state}>
        {engaged ? engagedLabel : bypassedLabel}
      </span>
    </div>
  )
}
